<template>
  <div class="category-form-wrap">
    <div class="form-group">
      <base-label for="category-name" :required="true">
        Название категории
      </base-label>
      <base-input
        type="text"
        id="category-name"
        v-model="formData.name"
        :invalid="errors.name"
        @update:modelValue="errors.name = false"
      />
      <span class="error-message" v-if="errors.name">
        Поле обязательно для заполнения
      </span>
    </div>

    <div class="form-group">
      <base-label :required="true">Эмодзи</base-label>
      <EmojiSelect
        v-model="formData.emoji"
        :invalid="errors.emoji"
        @update:modelValue="errors.emoji = false"
      />
      <span class="error-message" v-if="errors.emoji">
        Поле обязательно для заполнения
      </span>
    </div>

    <div class="form-group">
      <base-checkbox v-model="formData.requires_liters">
        Требуется указание литров
      </base-checkbox>
    </div>

    <div v-if="!hideActions" class="inline-form-actions">
      <base-primary-button
        @click="save"
        :loading="isLoading"
        class="btn-sm"
      >
        {{ submitLabel }}
      </base-primary-button>
      <base-button @click="$emit('cancel')" class="btn-sm">
        Отмена
      </base-button>
    </div>
  </div>
</template>

<script>
import { transliterate } from "@/utils/translitUtils";

import { useNotificationStore } from "@/stores/notificationStore";

import EmojiSelect from "@/components/Expense/EmojiSelect.vue";

export default {
  name: "ExpenseCategoryForm",
  components: {
    EmojiSelect,
  },
  props: {
    initialData: { type: Object, default: null },
    isLoading: { type: Boolean, default: false },
    submitLabel: { type: String, default: "Сохранить" },
    hideActions: { type: Boolean, default: false },
  },
  emits: ["save", "cancel"],
  data() {
    return {
      formData: {
        name: "",
        emoji: "",
        requires_liters: false,
      },
      errors: {
        name: false,
        emoji: false,
      },
    };
  },
  computed: {
    notificationStore() {
      return useNotificationStore();
    },
  },
  methods: {
    initForm() {
      if (!this.initialData) return;
      this.formData = {
        name: this.initialData.name || "",
        emoji: this.initialData.emoji || "",
        requires_liters: this.initialData.requires_liters || false,
      };
    },

    validate() {
      let isValid = true;
      this.errors = { name: false, emoji: false };

      if (!String(this.formData.name || "").trim()) {
        this.errors.name = true;
        isValid = false;
      }
      if (!this.formData.emoji) {
        this.errors.emoji = true;
        isValid = false;
      }

      if (!isValid) {
        this.notificationStore.showError(
          "Пожалуйста, заполните все обязательные поля корректно"
        );
      }

      return isValid;
    },

    // публичный метод - вызывается через $refs из родителя
    save() {
      if (!this.validate()) {
        this.$nextTick(() => {
          const firstErrorElement = document.querySelector(
            ".invalid, .error-message"
          );
          if (firstErrorElement) {
            const formGroup =
              firstErrorElement.closest(".form-group");
            (formGroup || firstErrorElement).scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        });
        return;
      }

      this.$emit("save", {
        name: String(this.formData.name || "").trim(),
        code: transliterate(String(this.formData.name || "").trim()),
        emoji: this.formData.emoji,
        requires_liters: this.formData.requires_liters,
      });
    },
  },
  created() {
    this.initForm();
  },
};
</script>

<style scoped>
.category-form-wrap {
  display: flex;
  flex-direction: column;
}

.error-message {
  display: block;
  margin-top: 5px;
  color: var(--color-danger);
  font-size: 12px;
}

.inline-form-actions {
  display: flex;
  gap: 8px;
}

.btn-sm {
  height: 32px;
  min-height: 32px;
  padding: 0 12px;
  font-size: 13px;
  box-sizing: border-box;
}
</style>
